<template>
<div>
	<Modal
    v-model="showModal"
    :width="modalWidth + 'px'"
    :mask-closable="false"
    class-name="register-modal"
    @on-cancel="cancel"
  >
    <div class="content">
      <Steps :current="currentSetp" size="small">
        <Step title="个人注册/实名"></Step>
        <Step title="完善企业信息"></Step>
        <Step title="企业实名认证"></Step>
      </Steps>
      <!-- 个人实名 -->
      <div class="reg-main"  v-show="showSetp == '0'">
				<p class="info">请扫码进行个人实名认证</p>
				<div class="qrcode" ref="qrCodeUrl"></div>
			</div>
      <!-- 加入企业 -->
      <div class="reg-main join" v-if="showSetp == '1'">
        <p class="decs">请选择您的企业名称</p>
        <Form ref="subForm" :model="subForm" :rules="formRules">
          <FormItem label="企业名称" prop="companyName" style="width: 600px">
            <Select
              v-model.trim="subForm.companyName"
              class="no-icon"
              style="width: 355px; margin-left: -150px;text-align: left;"
              filterable
              remote
              placeholder="请输入企业全称"
              :remote-method="companySearch"
            >
              <Option
                v-for="option in companyList"
                :value="option.customerName"
                :key="option.customerName"
                >{{ option.customerName }}</Option
              >
            </Select>
            <p style="text-align: left;padding-left: 85px;color: #f00" v-if="showValidate">您的企业还未创建账户, 请前往<span class="login" @click="showSetp = 2">【创建企业账号】</span></p>
            
          </FormItem>
        </Form>
        <p>此处需要您的营业执照,请提前准备</p>
      </div>
      <!-- 创建企业 -->
      <div class="reg-main" v-if="showSetp == '2'">
        <create-company @next="next" @createCompany="createCompany" @getCompany="getCompany" :companyName="subForm.companyName"></create-company>
      </div>
      <!-- 加入企业成功 -->
      <div class="reg-main success4" v-if="showSetp == '3'">
        <i
          class="iconfont icon"
          style="
            color: #409eff;
            font-size: 40px;
            margin: 30px auto;
            display: block;
          "
          >&#xe6f3;</i
        >
        <div class="txt">
          鸭嘴兽已收到您的加入企业信息, 我们将在30分钟内完成审核。
        </div>
        <div class="txt">审核结果将通过短信和微信通知您。</div>
        <div class="txt">如需紧急开通，请电话联系：{{ phone }}</div>
      </div>
      <!-- 创建企业成功 -->
      <div class="reg-main success4" v-if="showSetp == '7'">
        <i
          class="iconfont icon"
          style="
            color: #409eff;
            font-size: 40px;
            margin: 30px auto;
            display: block;
          "
          >&#xe6f3;</i
        >
        <div class="txt">您的企业已创建成功!</div>
        <div class="txt">点击下一步完成企业实名认证获取更多额度!</div>
      </div>
      <!-- 企业实名认证 -->
      <div class="reg-main success5" v-if="showSetp == '4'">
        <div class="txt ">
          应监管部门要求，为了保证贵司账号安全，避免产生法律风险，贵公司需要在网站进行企业实名认证。我们将采取对公打款认证，授权书认证或法定代表人认证的方式来验证您的本人与企业的身份，您的个人与企业信息将得到绝对的保护。
        </div>
      </div>
      <!-- 企业实名成功 -->
      <div class="reg-main success4" v-if="showSetp == '5'">
        <i
          class="iconfont icon"
          style="
            color: #409eff;
            font-size: 40px;
            margin: 30px auto;
            display: block;
          "
        >&#xe6f3;</i>
        <div class="txt">企业实名认证成功</div>
      </div>
			
			<statement @next="next" v-if="showSetp == '6'" :isShow="statementFlag"></statement>
    </div> 
    <div slot="footer">
      <Button
          type="primary"
          size="large"
          class="next-btn"
          style="width: 200px"
					v-if="showSetp == '0'"
          @click="hasCertificationHttp(1)"
        >
          下一步
        </Button>
        <Button
          type="primary"
          size="large"
          @click="valiSubmit('subForm')"
          :loading="joinLoading"
          v-if="showSetp == '1'"
        >
          立即加入
        </Button>
        <Button
          type="text"
          class="next-btn"
          style="width: 200px;border-color:#fff"
          @click="showModal = false"
          v-if="showSetp == '4'"
        >
          暂不实名
        </Button>
        <Button
          type="primary"
          size="large"
          @click="getOrgAuthUrl"
          :loading="loading"
          v-if="showSetp == '4'"
        >
          立即企业实名
        </Button>
        <Button
          type="primary"
          size="large"
          class="next-btn"
          style="width: 200px"
					v-if="showSetp == '7'"
          @click="showSetp = 4"
        >
          下一步
        </Button>
    </div>
  </Modal>
</div>
  
</template>

<script>
import Cookies from 'js-cookie';
import {
  companySearch,
  getUserCompanyInfoByName,
  applyForCompany,
  getPhoneNumber,
	validateCompany,hasCertification
} from "@/api/home";
import createCompany from "./create-company.vue";
import QRCode from 'qrcodejs2'
import statement from "./statement"
import { encrypt, decode } from "@/libs/encrypt-and-decode.js"
import { userInfo, orgAuthUrl, orgAuthStatus, } from "@/api/certification";
export default {
  components: { createCompany, statement },
	props:{
		title:{
			type: String,
			default:"user"
		}
	},
  data() {
		const validateCompanyName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入企业名"));
      } else {
        if (this.timeOutValide) clearTimeout(this.timeOutValide);
        var timeOutValide = setTimeout(() => {
          value && validateCompany({
            keywords: value
          }).then(res => {
            if (res && res.data.code == "CUS-1028") {
              this.showValidate = false
              callback();
            } else if (res.data.code == 0) {
              this.showValidate = true
            } else {
              this.showValidate = false
              callback(new Error(res.data.msg));
            }
          })
        }, 200);
      }
    };
    return {
      currentSetp: 0,
      showValidate:false,
			modalWidth: "550",
      showModal: false,
      QRcodeImgUrl: null,
      webSocketKey: null,
      showSetp: 0,
      subForm: {
        companyName: null,
      },
      formRules: {
        companyName: [
          {
            required: true,
            validator: validateCompanyName,
            trigger: "change",
          },
        ],
      },
      joinLoading: false,
      companyList: [],
      loading: false,
      phone: null,
      userInfo: {}
    };
  },
	watch:{
		"showSetp"(val){
			if (val == 2){
				this.modalWidth = "1000"
			}else if (val == 5){
        this.modalWidth = "550"
        this.currentSetp = this.userInfo.companyId ? 2 : 1
			}else {
				this.modalWidth = "550"
			}
		},
	},
	mounted(){
    if(Cookies.get('user')) this.getUserInfo()
	},
  methods: {
    // 获取个人信息
    getUserInfo() {
      userInfo({}).then((res) => {
        if (res && res.data.success) {
          this.userInfo = res.data.data
          this.init()
        }
      });
    },
    init(){
      if(this.userInfo.personalCertificationStatus != "Verify") {
        this.showSetp = 0
        this.currentSetp = 0
        this.$nextTick( ()=> {
			    this.qrcode()
		    })
        return
      }
      if(!this.userInfo.companyId) {
        this.showSetp = 1
        this.currentSetp = 1
        return
      }
			if(this.userInfo.companyCertificationStatus != "Verify") {
        this.showSetp = 4
        this.currentSetp = 2
        return
      }
      if(this.userInfo.companyCertificationStatus == "Verify") {
        this.showSetp = 5
        this.currentSetp = 2
        return
      }
    },
    getCompany(val){
      this.subForm.companyName = val
      this.companySearch(val)
    },
		qrcode() {
			let url = ''
			if(window.location.host.indexOf('fat')>-1){
				url = `http://wechatcustomer.fat.driverglobe.com/register/statement/?flag=user&userId=${decode(Cookies.get('user'))}`
			}else {
				url = `https://wechatcustomer.carrierglobe.com/register/statement/?flag=user&userId=${decode(Cookies.get('user'))}`
			}
      if (this.$refs.qrCodeUrl){
        this.$refs.qrCodeUrl.innerHTML = ''
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: url,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    show(flag) {
      this.showModal = flag != undefined ? flag : true;
    },
    // 获取企业list
    companySearch: _.debounce(function (value) {
      value &&
        companySearch({
          name: value,
        }).then((res) => {
          if (res && res.data.success) {
            this.companyList = res.data.objs;
          }
        });
    }, 800),
		next(flag){
			this.showSetp = flag;
		},
		hasCertificationHttp(){
			hasCertification({
				userId: decode(Cookies.get('user'))
			}).then(res => {
				if (res && res.data.success) {
					if(!res.data.data){
						this.$Message.error("您尚未完成个人实名认证");
					}else {
						this.getUserInfo()
					}
        }
			})
		},
    // 获取企业核身认证地址
    getOrgAuthUrl() {
      orgAuthUrl().then((res) => {
        if (res && res.data.success) {
          this.loading = true
          // 企业认证结果轮询
          this.timer = window.setInterval(() => {
            setTimeout(() => {
              this.getOrgAuthStatus(res.data.data.flowId);
            }, 1);
					}, 5000);
          window.open(res.data.data.url);
        }else {
					this.$Message.error(res.data.msg)
				}
      });
    },
    // 企业认证轮训
    getOrgAuthStatus(id) {
      orgAuthStatus({
        id: id,
      }).then((res) => {
        if (res && res.data.success) {
          if (res.data.data.status == 'Verify') {
						clearInterval(this.timer);
            this.loading = false
            // this.getUserInfo()
            this.$router.push({
              path: '/query-charge-new'
            })
          }
        }
      })
		},
    valiSubmit(key) {
      this.$refs[key].validate((valid) => {
        if (valid) {
          this.checkCompany();
        }
      });
    },
    // 判断企业是否可以加入
    checkCompany() {
      this.joinLoading = true
      getUserCompanyInfoByName({
        companyName: this.subForm.companyName,
      }).then((res) => {
        if (res && res.data.success) {
          let data = JSON.parse(res.data.data.value);
          if (data && data.data) {
            this.applyForCompanyHttp(JSON.parse(data.data).id);
          } else {
            this.$Message.error(data.message);
            this.joinLoading = false
          }
        }
      });
    },
    // 用户申请加入企业
    applyForCompanyHttp(id) {
      applyForCompany({
        companyId: id,
      }).then((res) => {
        this.joinLoading = false
        if (res && res.data.success) {
          this.showSetp = 3;
           this.getContactPhone()
        } else {
          this.$Message.error(res.data.message);
        }
      });
    },
    // 获取联系电话
    getContactPhone() {
      getPhoneNumber().then((res) => {
        if (res) {
          this.phone = res.data.data;
        }
      });
    },
    toPath(pathName) {
      this.$router.push({
        path: pathName,
      });
    },
    cancel() {
      this.showModal = false;
    },
		createCompany(data){
			if(data){
        this.showSetp = 7
        this.currentSetp = 2;
			}
		}
  },
};
</script>

<style lang="less">
.register-modal {
  display: flex;
  align-items: center;
  justify-content: center;
	text-align: left;
  .ivu-steps-item.ivu-steps-status-process .ivu-steps-head-inner {
    background: #02cad6;
    border-color: #02cad6;
  }
  .ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner {
    border-color: #02cad6;
  }
  .ivu-steps-item.ivu-steps-status-finish .ivu-steps-tail>i:after {
    background: #02cad6;
  }
  .ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner>.ivu-steps-icon, .ivu-steps-item.ivu-steps-status-finish .ivu-steps-head-inner span {
    color: #02cad6;
  }
  .ivu-form-item-error-tip {
    margin-left: 40px;
  }
  .ivu-steps {
    text-align: left;
  }
  .ivu-modal {
    top: 0;
  }
  .content {
    text-align: center;
    padding: 16px;
    .icon {
      font-size: 32px;
    }
  }
  .logo {
    width: 140px;
  }
  .alert-logo {
    margin: 0 auto;
    width: 40px;
  }
  .reg-main {
    .qrcode {
      width: 200px;
      margin: 20px auto;
    }
    .top-txt {
      font-size: 15px;
      margin: 20px 30px;
      text-align: center;
      color: #02cad6;
    }
    .title {
      border-bottom: 1px solid #e0e0e0;
      font-size: 18px;
      color: #333;
      text-align: left;
      line-height: 40px;
      margin-top: -26px;
    }
    .decs {
      color: #8c9093;
      font-size: 14px;
      text-align: left;
      margin: 20px 0;
    }
		
  }
	.info {
			font-size: 14px;
    	margin: 30px;
		}
  .f-s14 {
    font-size: 13px;
    margin-top: 7px;
    .txt {
      font-size: 14px;
    }
  }
  .success {
    text-align: left;
    font-size: 13px;
    line-height: 22px;
  }
  .success4 {
    font-size: 14px;
    line-height: 25px;
  }
  .success5 {
    font-size: 14px;
    line-height: 25px;
    text-indent: 2em;
    padding-top: 20px;
    text-align: left;
  }
  .login {
    color: #02cad6;
    cursor: pointer;
  }

  button {
    display: block;
    margin: 10px auto;
    width: 40%;
		background: #02cad6;
		border-color: #02cad6;
  }
	.ivu-btn-primary:hover {
		background: #02cad6;
		border-color: #02cad6;
	}
  .next-btn {
    border-color: #02cad6;
    color: #02cad6;
    background: #fff;
  }
  .ivu-modal-footer {
    border: none;
    padding-bottom: 30px;
    text-align: center;
  }
	.join .ivu-form-item-error-tip {
    margin-left: 85px;
	}
  .ivu-modal-footer button+button {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6470af48